export default "__VITE_ASSET__DrR$AcOc__"